class DiscordStaffStyling {
  constructor() {
    this.swiper = null;
    this.imageSlider = null;
    this.itemList = null;
    this.init();
  }

  init() {
    // Swiperが読み込まれるまで待機
    if (typeof Swiper !== 'undefined') {
      this.initSwiper();
    } else {
      // Swiperが読み込まれていない場合は少し待って再試行
      setTimeout(() => {
        this.init();
      }, 100);
    }
    this.setupProductClicks();
    this.setupGSAPStickyBehavior();
  }

  initSwiper() {
    const swiperContainer = document.querySelector('.image-slider.swiper-container');
    if (!swiperContainer) return;

    console.log('Initializing main image slider');
    this.swiper = new Swiper(swiperContainer, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      loop: true,
      speed: 800,
      allowTouchMove: false, // タッチ操作を無効化（必要に応じて削除）
      on: {
        init: function() {
          console.log('Swiper initialized');
        }
      }
    });
  }

  setupProductClicks() {
    const productItems = document.querySelectorAll('.staff-styling-item');

    // productItems.forEach((item, index) => {
    //   const productLink = item.querySelector('.staff-styling-box');
    //   if (productLink && productLink.href) {
    //     item.addEventListener('click', (e) => {
    //       // リンクがクリックされた場合は自然にナビゲート
    //       if (e.target.closest('.staff-styling-box')) {
    //         return;
    //       }
    //       // アイテム全体がクリックされた場合
    //       window.location.href = productLink.href;
    //     });
    //   }
    // });
  }

  // Swiperを停止
  stopSwiper() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.stop();
    }
  }

  // Swiperを開始
  startSwiper() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.start();
    }
  }

  // Swiperを破棄
  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  // GSAP Sticky behavior setup
  setupGSAPStickyBehavior() {
    this.imageSlider = document.querySelector('.image-slider');
    this.itemList = document.querySelector('.staff-styling-itemlist');

    if (!this.imageSlider || !this.itemList) return;

    // GSAPが読み込まれているかチェック
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      this.initGSAPSticky();
    } else {
      // GSAPを動的に読み込み
      this.loadGSAP();
    }
  }

  loadGSAP() {
    // GSAPとScrollTriggerをCDNから読み込み
    const gsapScript = document.createElement('script');
    gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js';
    gsapScript.onload = () => {
      const scrollTriggerScript = document.createElement('script');
      scrollTriggerScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js';
      scrollTriggerScript.onload = () => {
        gsap.registerPlugin(ScrollTrigger);
        this.initGSAPSticky();
      };
      document.head.appendChild(scrollTriggerScript);
    };
    document.head.appendChild(gsapScript);
  }


  initGSAPSticky() {
    // PC画面幅の判定（768px以上）
    const isPCScreen = () => window.innerWidth > 768;

    if (!isPCScreen()) {
      // SP画面の場合は通常のCSSのままにする
      return;
    }

    const itemList = this.itemList;
    const imageSlider = this.imageSlider;

    if (!itemList || !imageSlider) return;

    // 既存のScrollTriggerをクリーンアップ
    ScrollTrigger.getAll().forEach(trigger => {
      if (trigger.trigger === imageSlider || trigger.trigger === itemList) {
        trigger.kill();
      }
    });

    // ScrollTriggerを使ったsticky実装
    ScrollTrigger.create({
      trigger: itemList,
      start: "top-=200 top+=200",
      end: "bottom-=100 top+=200",
      pin: imageSlider,
      pinSpacing: false,
    });

    // リサイズ対応
    const onResize = () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        if (!isPCScreen()) {
          // SP画面になった場合はScrollTriggerを無効化
          ScrollTrigger.getAll().forEach(trigger => {
            if (trigger.trigger === imageSlider || trigger.trigger === itemList) {
              trigger.kill();
            }
          });
        } else {
          // PC画面に戻った場合は再初期化
          ScrollTrigger.refresh();
        }
      }, 150);
    };

    window.addEventListener('resize', onResize, { passive: true });
  }
}

// DiscordStaffStylingクラスを初期化
document.addEventListener('DOMContentLoaded', function() {
  new DiscordStaffStyling();
});
